export const GENERAL_CONSTANTS = {
    PAYMENT_QUERY_PARAM_KEY: "payment",
    PAYMENT_QUERY_PARAM_VALUE_SUCCESS: "success",
    PAYMENT_QUERY_PARAM_VALUE_FAIL: "fail",
}
